<div [hidden]="!isVisible" class="page-splash dissolve-animation">
  <div class="page-splash-content">
    <span class="cmnh-spinner" aria-hidden="true"></span>
    <div class="page-splash-message page-splash-message-subtle">
      {{ message }}
    </div>
  </div>
</div>
